import theme from 'shared/styles/theme';

export const getChatTextFieldStyles = (
  error: boolean,
  focus: boolean,
  readOnly: boolean,
  placeholder: boolean,
) => {
  let borderColor = theme.color.border.primary;
  let textColor = placeholder
    ? theme.color.text.secondary
    : theme.color.text.primary;

  if (error) {
    borderColor = theme.color.status.negative;
  } else if (focus) {
    borderColor = theme.color.interactive.primary;
  } else if (readOnly) {
    borderColor = theme.color.interactive.disabled.border;
    textColor = theme.color.text.muted;
  }

  return { borderColor, textColor };
};
